import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getItem } from '../../utils/localstorage'

import Aside from '../Aside'
import Header from '../Header'

import { Content, Container } from './styles'
import { TOKEN_KEY } from '../../utils/constants'

export default function Layout({
	token,
	handleProfile = () => undefined,
	hideHeader = false,
	hideProfile = false,
	hideAside = false,
	attendance = false,
	showAllAttendance = false,
	children,
}) {
	const navigate = useNavigate()
	const tokenValue = getItem(TOKEN_KEY)

	useEffect(() => {
		if (!getItem(TOKEN_KEY)) {
			navigate('/')
		}
	}, [tokenValue, navigate])

	return (
		<Content>
			{hideHeader ? null : (
				<Header hideProfile={hideProfile} handleProfile={handleProfile} />
			)}
			<Container>
				{hideAside ? null : (
					<Aside
						admin={token}
						showAttendance={attendance}
						showAllAttendance={showAllAttendance}
					/>
				)}
				{children}
			</Container>
		</Content>
	)
}
